import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import { getWeighBridgeTSSCTPWiseSummary, getZoneDetails } from "../../../../Apis/ttrReportsApi";
import Header from "../../../../Common/Header/header";
import Sidebar from "../../../../Common/Sidebar/sidebar";
import DataTable from "react-data-table-component";
import { useLocation } from "react-router-dom";
import isGHMC from "../../../../Common/helper/helpar";

const TripTonnageDetailReport = ({ t }) => {
    const {
        register,
        handleSubmit,
        watch,
        reset,
        setValue,
        formState: { errors },
    } = useForm();

    const [zoneData, setZoneData] = useState([]);
    const [TSSCTPData, setTSSCTPData] = useState([]);
    const [fetchTSSCTPData, setFetchTSSCTPData] = useState([]);
    const location = useLocation();
    const isProd = isGHMC();

    const fetchZoneData = async () => {
        try {
            const response = await getZoneDetails();
            setZoneData(response.data);
            // console.log(response.data, '--zone data from tssctp--')
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchZoneData();
    }, [])

    // const fetchData = async (data) => {
    //     try {
    //         await new Promise(resolve => setTimeout(resolve, 1000));
    //         const FromDate = data?.FromDate || '';
    //         const ToDate = data?.ToDate || '';
    //         const zoneId = data?.zoneId || '';
    //         const ulb = 0; // assuming ulb is a constant value
    //         const requestData = { FromDate, ToDate, zoneId, ulb };

    //         const response = await getWeighBridgeTSSCTPWiseSummary(requestData);
    //         console.log(response.data.Data, 'fetch Data response.data.Data')
    //         return response.data.Data;

    //     } catch (error) {
    //         console.log(error);
    //         return [];
    //     }
    // };

    useEffect(() => {
        if (location.state && location.state.data) {
            // Fetch and set data if it's available in location state

            const newData = location.state.data.Data.map(item => {
                const total_Trips = item.count_GHMC + item.count_HIMSW + item.count_HIRE;
                const total_Tonnage = (item.sum_GHMC + item.sum_HIMSW + item.sum_HIRE) / 1000;
                return {
                    ...item,
                    GHMC_Tonnage: (item.sum_GHMC / 1000).toFixed(2),
                    HIMSW_Tonnage: (item.sum_HIMSW / 1000).toFixed(2),
                    HIRE_Tonnage: (item.sum_HIRE / 1000).toFixed(2),
                    GHMC_Trips: item.count_GHMC,
                    HIMSW_Trips: item.count_HIMSW,
                    HIRE_Trips: item.count_HIRE,
                    total_Trips,
                    total_Tonnage,
                };
            });

            setFetchTSSCTPData(newData);
            // setFetchTSSCTPData(location.state.data.Data);
            // fetchTSSCTP(location.state.data.Data);
            // console.log(newData, 'location.state.data.Data')
        }
    }, [location.state]);
    // console.log(fetchTSSCTPData, 'fetchTSSCTPData')

    // const handleSearch = async (formData) => {
    //     const newData = await fetchData(formData);
    //     setFetchTSSCTPData(newData);
    // };

    const fetchTSSCTP = async (data) => {
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const FromDate = data && data.FromDate ? data.FromDate : "";
            const ToDate = data && data.ToDate ? data.ToDate : "";
            const zoneId = data && data.zoneId ? data.zoneId : "";
            const requestData = {
                FromDate,
                ToDate,
                zoneId,
                ulb: 0,
            };
            const response = await getWeighBridgeTSSCTPWiseSummary(requestData);
            // setTSSCTPData(response.data.Data);
            // console.log(response.data.Data, 'response.data.Data')
            const newData = response.data.Data.map(item => {
                const total_Trips = item.count_GHMC + item.count_HIMSW + item.count_HIRE;
                const total_Tonnage = (item.sum_GHMC + item.sum_HIMSW + item.sum_HIRE) / 1000;
                return {
                    ...item,
                    GHMC_Tonnage: (item.sum_GHMC / 1000).toFixed(2),
                    HIMSW_Tonnage: (item.sum_HIMSW / 1000).toFixed(2),
                    HIRE_Tonnage: (item.sum_HIRE / 1000).toFixed(2),
                    GHMC_Trips: item.count_GHMC,
                    HIMSW_Trips: item.count_HIMSW,
                    HIRE_Trips: item.count_HIRE,
                    total_Trips,
                    total_Tonnage,
                };
            });

            // setTSSCTPData(newData);
            setFetchTSSCTPData(newData);
            // console.log(response.data.Data, 'fetch TSSCTP')
            // console.log(newData, 'newData --------- fetch TSSCTP')

        } catch (error) {
            console.log(error)
        }
    }

    const customStyles = {
        rows: {
            style: {
                backgroundColor: 'rgb(248, 204, 205)',
                cursor: 'pointer',
                '&:nth-child(2n)': {
                    backgroundColor: '#fff',
                },
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                color: '#fff',
                backgroundColor: 'rgb(236, 17, 23)',
                fontFamily: 'Arial',
                fontWeight: '600',
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
            },
        },
    }
    const columns = [
        {
            name: 'Sl.No',
            selector: (row) => row['slno'], // Corrected selector
            sortable: true,
            format: (row, rowIndex) => rowIndex + 1,
        },
        {
            name: 'zoneName',
            selector: (row) => row['zoneName'],
            sortable: true,
        },
        {
            name: 'TS_SCTP',
            selector: (row) => row['TS_SCTP'],
            sortable: true,
        },
        {
            name: 'GHMC_Trips',
            selector: (row) => row['GHMC_Trips'],
            sortable: true,
        },
        {
            name: 'HIMSW_Trips',
            selector: (row) => row['HIMSW_Trips'],
            sortable: true,
        },
        {
            name: 'HIRE_Trips',
            selector: (row) => row['HIRE_Trips'],
            sortable: true,
        },
        {
            name: 'total_Trips',
            selector: (row) => row['total_Trips'],
            sortable: true,
        },
        {
            name: 'GHMC_Tonnage',
            selector: (row) => row['GHMC_Tonnage'],
            sortable: true,
        },
        {
            name: 'HIMSW_Tonnage',
            selector: (row) => row['HIMSW_Tonnage'],
            sortable: true,
        },
        {
            name: 'HIRE_Tonnage',
            selector: (row) => row['HIRE_Tonnage'],
            sortable: true,
        },
        {
            name: 'total_Tonnage',
            selector: (row) => row['total_Tonnage'],
            sortable: true,
        },
    ]



    // Calculate totals
    const totalGHMC_Trips = fetchTSSCTPData.reduce((total, item) => total + item.GHMC_Trips, 0);
    const totalHIMSW_Trips = fetchTSSCTPData.reduce((total, item) => total + item.HIMSW_Trips, 0);
    const totalHIRE_Trips = fetchTSSCTPData.reduce((total, item) => total + item.HIRE_Trips, 0);
    const total_total_Trips = fetchTSSCTPData.reduce((total, item) => total + item.total_Trips, 0);
    const totalGHMC_Tonnage = fetchTSSCTPData.reduce((total, item) => total + parseFloat(item.GHMC_Tonnage), 0).toFixed(2);
    const totalHIMSW_Tonnage = fetchTSSCTPData.reduce((total, item) => total + parseFloat(item.HIMSW_Tonnage), 0).toFixed(2);
    const totalHIRE_Tonnage = fetchTSSCTPData.reduce((total, item) => total + parseFloat(item.HIRE_Tonnage), 0).toFixed(2);
    const total_total_Tonnage = fetchTSSCTPData.reduce((total, item) => total + parseFloat(item.total_Tonnage), 0).toFixed(2);

    // Add an extra row for total
    const totalRow = {
        slno: "Total",
        zoneName: "Total",
        GHMC_Trips: totalGHMC_Trips,
        HIMSW_Trips: totalHIMSW_Trips,
        HIRE_Trips: totalHIRE_Trips,
        total_Trips: total_total_Trips,
        GHMC_Tonnage: totalGHMC_Tonnage,
        HIMSW_Tonnage: totalHIMSW_Tonnage,
        HIRE_Tonnage: totalHIRE_Tonnage,
        total_Tonnage: total_total_Tonnage,
    };

    // Combine the original data with the total row
    const dataWithTotalRow = [...fetchTSSCTPData, totalRow];

    const conditionalRowStyles = [
        {
            when: (row) => row && row.hasOwnProperty('slno') && row['sl.no'] === 'Total',
            style: {
                backgroundColor: 'rgb(68, 61, 61)', // Change background color to black
                color: '#fff',
            },
        },
    ];

    return (
        <>
            <div style={{ width: "100%" }} className={`${isProd ? "ghmc-true" : "ghmc-false"} App`}>
                <Header />
                <Sidebar />
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className="text-end mb-3">
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit(fetchTSSCTP)}>
                                    <div className="row" style={{ textAlign: "left" }}>
                                        <div className="col-md-3 mb-3">
                                            <label>Select From Date:</label>
                                            <input
                                                className="form-control"
                                                type="datetime-local"
                                                name="FromDate"
                                                {...register("FromDate")}
                                                // {...register("FromDate", { value: FromDate || "" })}
                                                style={{ backgroundColor: "#fff" }}
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label>Select To Date:</label>
                                            <input
                                                className="form-control"
                                                type="datetime-local"
                                                name="ToDate"
                                                {...register("ToDate")}
                                                // {...register("ToDate", { value: ToDate || "" })}
                                                style={{ backgroundColor: "#fff" }}
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label>Select Zone:</label>
                                            <select
                                                className="form-select"
                                                name="zoneId"
                                                {...register("zoneId")}
                                                // {...register("zoneId", { value: zoneId || "" })}
                                                style={{ backgroundColor: "#fff" }}
                                            >
                                                <option value="">--select--</option>
                                                {zoneData.map((zone) => (
                                                    <option value={zone.zoneId}>{zone.zoneName}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label>Select TSSCTP:</label>
                                            <select
                                                className="form-select"
                                                name="tssctp"
                                                {...register("tssctp")}
                                                style={{ backgroundColor: "#fff" }}
                                            >
                                                <option value="">--select--</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label>Select Transporter:</label>
                                            <select
                                                className="form-select"
                                                name="tssctp"
                                                {...register("tssctp")}
                                                style={{ backgroundColor: "#fff" }}
                                            >
                                                <option value="">--select--</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col text-left"
                                            style={{ display: "flex", justifyContent: "flex-end" }}
                                        >
                                            <button
                                                type="submit"
                                                style={{
                                                    borderRadius: "20px",
                                                    width: "100px",
                                                    display: "flex",
                                                    height: "40px",
                                                    justifyContent: "center",
                                                    backgroundColor: "red",
                                                    color: "#fff",
                                                    border: "none",
                                                    alignItems: "center",
                                                }}
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card mt-3">
                                <div className="card-body">
                                    <div className="top-header">
                                        <span>{t("Trips & Tonnage Detailed Report")} </span>
                                    </div>
                                    <DataTable
                                        columns={columns}
                                        data={location.state && location.state.data ? dataWithTotalRow : TSSCTPData}
                                        pagination
                                        customStyles={customStyles}
                                        // highlightOnHover
                                        noDataComponent="Loading..."
                                        conditionalRowStyles={conditionalRowStyles}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTranslation()(TripTonnageDetailReport);